import type { TranslateFn } from '@/types/i18n';

/** The translation of `key`, or `fallback` when the key is missing or has no translation. */
export function translatedOr(
  t: TranslateFn,
  key: string | null | undefined | false | '',
  fallback: string,
  params?: Record<string, string | number>
): string {
  if (!key) return fallback;
  const text = t(key, params);
  // The feature hook hands back the bare key when there is no translation.
  return text === key ? fallback : text.trim();
}
